<template>
  <div class="approval-config-form">
    <b-row>
      <b-col md="3">
        <b-form-group :label="'Tên cấu hình'">
          <b-form-input
            class="input-style"
            size="sm"
            type="text"
            v-model="formData.name"
            placeholder="Tên cấu hình"
            :disabled="formData.disabled"
          ></b-form-input>
        </b-form-group>
        <b-form-group :label="'Số bước'">
          <b-form-input
            class="input-style text-right"
            size="sm"
            type="text"
            v-model="formData.numOfStep"
            placeholder="Nhập số bước"
            v-mask="currency"
            :disabled="formData.disabled"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group :label="'Loại chi'">
          <b-form-select
            class="select-style"
            v-model="formData.approvalType"
            :options="typeOptions"
            size="sm"
            value-field="id"
            text-field="name"
            :disabled="!!formData.id"
          >
          </b-form-select>
        </b-form-group>
        <b-form-group :label="'Trạng thái'">
          <b-form-select
            class="select-style"
            v-model="formData.isActive"
            :options="statusOptions"
            size="sm"
            value-field="id"
            text-field="name"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { currencyMask } from '@/utils/common';

export default {
  name: 'ApprovalConfigForm',
  props: {
    /**
     * Form data for the approval config
     */
    value: {
      type: Object,
      required: true
    },
    /**
     * List of approval types
     */
    typeOptions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currency: currencyMask,
      statusOptions: [
        {
          id: 1,
          name: 'Hoạt động',
        },
        {
          id: 0,
          name: 'Không hoạt động',
        },
      ]
    };
  },
  computed: {
    /**
     * Computed property for two-way binding
     */
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.approval-config-form {
  .input-style {
    width: 100%;
  }
  
  .select-style {
    width: 100%;
  }
}
</style>
